import React, { Component } from 'react'

// import classes from './reportAppraisalByJobKpi.scss'
import {
  updateFilterOptions,
  extractFilterOptions,
  updateObject,
  clearFilterOptionValues
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import Grid from '@material-ui/core/Grid'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import { withTranslate } from 'react-redux-multilingual'

class ReportAppraisalByJobKpi extends Component {
  state = {
    filterModalOpen: false,
    filter: {},
    openPreview: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structure'),
          options: []
        },
        required: true
      },
      item_id: {
        label: this.props.translate('kpi'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('kpi'),
          options: [],
          disabled: false
        },
        required: false
      },
      format: {
        label: this.props.translate('format'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('format'),
          options: [
            { value: 'pdf', label: 'PDF' },
            { value: 'xlsx', label: 'Excel' }
          ]
        },
        required: true
      }
    },
    filterOptions: {
      companyFilterOptions: this.props.companyFilterOptions,
      structureFilterOptions: this.props.structureFilterOptions,
      itemFilterOptions: this.props.itemFilterOptions
    },
    // Presentational State
    company: null,
    filteredCache: null
  }

  componentDidMount = () => {
    this.props.fetchCompanyOptions()

    if (this.props.filtered) {
      const { company } = this.props.filtered

      this.props.filterAppraisalRecords(this.props.filtered)

      this.setState({
        company
      })
    }
  }

  componentWillUnmount() {
    this.clearFilter()
    this.props.clearReportAppraisalByJobKpi()
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }
    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }
    if (props.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' }
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.companyFilterOptions
        }
      }
    }
    if (props.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.formFilterOptions
        }
      }
    }

    if (props.structureFilterOptions !== updatedState.filterOptions.structureFilterOptions) {
      const structureFilter = updatedState.filterControls.structure_id
      let updatedFilterItem = updateFilterOptions(
        props.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.structure_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          structure_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.structureFilterOptions
        }
      }
    }

    if (props.itemFilterOptions !== updatedState.filterOptions.itemFilterOptions) {
      const itemFilter = updatedState.filterControls.item_id
      let updatedFilterItem = updateFilterOptions(
        props.itemFilterOptions,
        itemFilter,
        'item_id',
        'item_id',
        { name: 'item_name', code: 'item_code' },
        'Select item'
      )

      updatedState = {
        filterControls: updateObject(updatedState.filterControls, {
          item_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          itemFilterOptions: props.itemFilterOptions
        }
      }
    }
    return updatedState
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter,
      filteredCache: null
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false,
      openPreview: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data
      let value = ''
      if (datakey === 'format') {
        value = { value: 'pdf', label: 'PDF' }
      }
      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: value }
      })
    })
    this.props.fetchCompanyOptions({ appraisal_type_id: 10 })
    this.props.fetchFormOptions({ appraisal_type_id: 10 })
    this.props.fetchStructureOptions({ appraisal_type_id: 10 })
    this.props.fetchItemsOptions({ appraisal_type_id: 10 })
    this.props.clearReportAppraisalByJobKpi()
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      openPreview: false,
      filter: []
    })
  }

  handleFilterChange = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    let filterOptions = extractFilterOptions(updatedFilterControls)
    filterOptions = { ...filterOptions, appraisal_type_id: 10 }
    // if (itemKey === 'appraisal_type_id') {
    //   this.props.fetchCompanyOptions(filterOptions)
    //   this.props.fetchFormOptions(filterOptions)
    //   this.props.fetchStructureOptions(filterOptions)
    //   this.props.fetchItemsOptions(filterOptions)
    // } else
    if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchItemsOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchItemsOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = extractFilterOptions(this.state.filterControls)
    let par = {
      param_appraisal_type: 10,
      param_company: filter?.company_id,
      param_form: filter?.form_id,
      param_structure_id: filter?.structure_id,
      param_item: filter?.item_id
    }
    let parameters = {}
    Object.entries(par).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })

    let param = {
      structure_id: filter?.structure_id,
      company_id: filter?.company_id,
      parameters: parameters,
      format: filter.format,
      locale: localStorage.getItem('language')
    }
    this.props.reportAppraisalByJobKpi(param)
    this.setState({
      openPreview: true
    })
    this.closeFilterModal()
  }

  render() {
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoading}
        />
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs sm md>
                  <PageInfo pageTranslateKey={'reportAppraisalByJobKpi'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }></CardHeader>
          <CardBody>{formLoading}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reportAppraisalByJobKpi.loading,
    filterLoading: state.reportAppraisalByJobKpi.loadingStates,
    success: state.reportAppraisalByJobKpi.success,
    filtered: state.reportAppraisalByJobKpi.success,
    companyFilterOptions: state.reportAppraisalByJobKpi.company,
    formFilterOptions: state.reportAppraisalByJobKpi.form,
    structureFilterOptions: state.reportAppraisalByJobKpi.structure,
    itemFilterOptions: state.reportAppraisalByJobKpi.item,
    // levelGroupFilterOptions: state.reportAppraisalByJobKpi.levelGroup,
    // orgFilterOptions: state.reportAppraisalByJobKpi.org,
    report: state.reportAppraisalByJobKpi.report
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptionsForAppraisal(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptionsForAppraisal(filter)),
    fetchStructureOptions: filterOptions =>
      dispatch(
        actions.fetchStructureOptionsForAppraisal({
          ...filterOptions,
          structure_type_code: ['STT01', 'STT04']
        })
      ),
    filterAppraisalRecords: filterOptions => dispatch(actions.fetchAppraisalData(filterOptions)),
    fetchItemsOptions: filterOptions =>
      dispatch(actions.fetchItemForPerformanceTrend(filterOptions)),
    reportAppraisalByJobKpi: filter => dispatch(actions.reportAppraisalByJobKpi(filter)),
    clearReportAppraisalByJobKpi: () => dispatch(actions.clearReportAppraisalByJobKpi())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ReportAppraisalByJobKpi))
